import React from "react";

export const Plus = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4667 15.2002H16.2667V12.0002C16.2667 11.5578 15.9091 11.2002 15.4667 11.2002C15.0243 11.2002 14.6667 11.5578 14.6667 12.0002V15.2002H11.4667C11.0243 15.2002 10.6667 15.5578 10.6667 16.0002C10.6667 16.4426 11.0243 16.8002 11.4667 16.8002H14.6667V20.0002C14.6667 20.4426 15.0243 20.8002 15.4667 20.8002C15.9091 20.8002 16.2667 20.4426 16.2667 20.0002V16.8002H19.4667C19.9091 16.8002 20.2667 16.4426 20.2667 16.0002C20.2667 15.5578 19.9091 15.2002 19.4667 15.2002Z"
      fill="currentColor"
    />
  </svg>
);

